import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";

import type { CellVerticalAlignment } from "@/components/tiptap/tables/TableCellVerticalAlignment";

type Props = {
  alignment?: CellVerticalAlignment | null;
  onSelect: (alignment: CellVerticalAlignment) => void;
};

export const TableCellAlignmentButtons = observer(function TableCellAlignmentButtons({
  alignment,
  onSelect,
}: Props) {
  const t = useTranslations("sidebar");

  const items = [
    {
      title: t("tableStyle.alignment.buttons.top"),
      icon: <Icon name="AlignTop" />,
      active: alignment === "top",
      onClick: () => onSelect("top"),
    },
    {
      title: t("tableStyle.alignment.buttons.center"),
      icon: <Icon name="AlignCenter" />,
      active: alignment === "center",
      onClick: () => onSelect("center"),
    },
    {
      title: t("tableStyle.alignment.buttons.bottom"),
      icon: <Icon name="AlignBottom" />,
      active: alignment === "bottom",
      onClick: () => onSelect("bottom"),
    },
  ];

  return (
    <div
      role="radiogroup"
      aria-label={t("toolbars.verticalAlignment")}
      className="grid grid-cols-3 gap-1"
    >
      {items.map((item) => {
        return (
          <Sidebar.Button
            key={item.title}
            icon={item.icon}
            aria-label={item.title}
            title={item.title}
            isActive={item.active}
            role="radio"
            aria-checked={item.active}
            onClick={item.onClick}
            className="w-9.5"
            inverted
          />
        );
      })}
    </div>
  );
});
